interface Props {
  label: string;
  src?: string;
  aspectRatio?: string;
  className?: string;
}

export default function ImagePlaceholder({ label, src, aspectRatio = "4/3", className = "" }: Props) {
  if (src) {
    return (
      <div className={`overflow-hidden ${className}`} style={{ aspectRatio }}>
        <img src={src} alt={label} loading="lazy" className="w-full h-full object-cover" />
      </div>
    );
  }

  return (
    <div className={`bg-[#F3F4F6] flex items-center justify-center ${className}`} style={{ aspectRatio }}>
      <span className="text-[13px] font-medium text-secondary/40 tracking-wide text-center px-4">{label}</span>
    </div>
  );
}
